export default "/assets/images/mila-room-showcase-sm-03.5f81c3ca6e577bee.jpg";